module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Orange-6a70ac0a76644433a80a0c3f356ae113.svg";